import { render } from "./BannerTop.vue?vue&type=template&id=fd45aaa2&scoped=true"
import script from "./BannerTop.vue?vue&type=script&lang=js"
export * from "./BannerTop.vue?vue&type=script&lang=js"

import "./BannerTop.vue?vue&type=style&index=0&id=fd45aaa2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd45aaa2"]])

export default __exports__